import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import FamilyRestroomOutlinedIcon from "@mui/icons-material/FamilyRestroomOutlined";
import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import MenuCard from "./MenuCard";

const PersonalSection = ({
  familyCount = 0,
  emergencyCount = 0,
  addressCount = 0,
  navigate,
}) => {
  const personalItems = [
    {
      title: "Family Members",
      subtitle: "Manage family profiles",
      icon: <FamilyRestroomOutlinedIcon />,
      badge: familyCount,
      color: "#5E35B1",
      onClick: () => navigate("/profile-details"),
    },
    {
      title: "Emergency Contacts",
      subtitle: "Manage emergency contacts",
      icon: <LocalHospitalOutlinedIcon />,
      badge: emergencyCount,
      color: "#E53935",
      onClick: () => navigate("/profile-details"),
    },
    {
      title: "Saved Address",
      subtitle: "Home, Work & Other address",
      icon: <HomeOutlinedIcon />,
      badge: addressCount,
      color: "#00897B",
      onClick: () => navigate("/profile-details"),
    },
  ];

  return (
    <Box>
      <Typography
        variant="h6"
        fontWeight={700}
        mb={2}
      >
        Personal
      </Typography>

      <Stack spacing={2}>
        {personalItems.map((item) => (
          <MenuCard
            key={item.title}
            title={item.title}
            subtitle={item.subtitle}
            icon={item.icon}
            badge={item.badge}
            color={item.color}
            onClick={item.onClick}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default PersonalSection;